module.exports = __webpack_public_path__ + "img/p41.fe375479.svg";